var _rect, _g, _g2, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailSentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 205,
    height: 205,
    rx: 8,
    fill: "#EFEFEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_6_9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.5,
    cy: 137,
    rx: 32.5,
    ry: 9,
    fill: "#CACACA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_6_9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: 98,
    rx: 33,
    ry: 10,
    fill: "#848484",
    fillOpacity: 0.29
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.4 100.837C119.106 100.827 114.991 99.1264 111.955 96.1058C108.919 93.0853 107.209 88.9913 107.2 84.7196C107.218 82.884 107.559 81.0657 108.208 79.3472H71.2C69.2904 79.3472 67.4591 80.1019 66.1088 81.4452C64.7586 82.7886 64 84.6106 64 86.5104V129.49C64 131.39 64.7586 133.212 66.1088 134.555C67.4591 135.899 69.2904 136.653 71.2 136.653H128.8C130.71 136.653 132.541 135.899 133.891 134.555C135.241 133.212 136 131.39 136 129.49V94.7124C134.502 96.615 132.59 98.1547 130.408 99.2156C128.225 100.276 125.829 100.831 123.4 100.837Z",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.831 99.4067L104.553 109.107C103.29 110.125 101.721 110.684 100.102 110.694C98.4699 110.693 96.8872 110.133 95.6144 109.107L64.4902 84.4412C64.9187 82.9364 65.8229 81.6124 67.0662 80.6691C68.3096 79.7259 69.8247 79.2145 71.3828 79.2123H108.287C107.64 80.9426 107.3 82.7733 107.281 84.6215C107.295 87.7461 108.202 90.801 109.895 93.4223C111.588 96.0436 113.996 98.1209 116.831 99.4067ZM123.436 72C120.951 72 118.522 72.7402 116.455 74.1271C114.389 75.514 112.779 77.4852 111.828 79.7914C110.877 82.0977 110.628 84.6355 111.113 87.0838C111.598 89.5321 112.794 91.7811 114.551 93.5462C116.309 95.3114 118.547 96.5134 120.985 97.0004C123.422 97.4875 125.948 97.2375 128.244 96.2822C130.54 95.3269 132.502 93.7092 133.883 91.6336C135.264 89.558 136 87.1178 136 84.6215C136 81.2741 134.677 78.0637 132.32 75.6967C129.964 73.3298 126.768 72 123.436 72Z",
    fill: "#45765A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.408 80L122.057 87.0753L118.252 83.4131L117 84.6185L122.057 89.4869L130.661 81.2062L129.408 80Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_6_9",
    x: 55,
    y: 116,
    width: 89,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_6_9"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_6_9",
    x: 58,
    y: 76,
    width: 90,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_6_9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSentIcon);
export default __webpack_public_path__ + "static/media/email-sent-icon.d40ff6a9de6efe118baa8058f06a0a9e.svg";
export { ForwardRef as ReactComponent };